<template>
    <div class="ap_home">
        <div class="g1">
            <div class="g1_cont">
                <p class="p1"></p>
                <p class="p2">AP课程</p>
                <p class="p3">美本直录最佳助力</p>
            </div>
        </div>
        <div class="g2">
            <div class="g2_cont">
                <div class="g2_item" @click="scrollg2item(0)">
                    <img src="../img/GAGD切图/Star 2.png" alt="">
                    <p>AP课程介绍</p>
                </div>
                <div class="g2_item" @click="scrollg2item(1)">
                    <img src="../img/GAGD切图/Star 2.png" alt="">
                    <p>AP课程优势</p>
                </div>
                <div class="g2_item" @click="scrollg2item(2)">
                    <img src="../img/GAGD切图/Star 2.png" alt="">
                    <p>RoSSo的服务与优势</p>
                </div>
                <div class="g2_item" @click="scrollg2item(3)">
                    <img src="../img/GAGD切图/Star 2.png" alt="">
                    <p>考试评估方式</p>
                </div>
            </div>
        </div>
        <div class="g3">
            <div class="g2_position">
            </div>
            <div class="g3_cont" style="margin-top: 70px;">
                <div class="g3_left">
                    <h1>什么是 “AP课程” ？</h1>
                    <div><span>美国大学先修课程（Advanced Placement）</span>
                        ，简称AP，是由美国大学理事会（College
                        Board）在高中阶段开设的具备大学水平的课程，目的是选拔出更优秀的学生。</div>

                        AP考试成绩受到美国大学的广泛认可，是美国大学录取学生的重要参考依据。另外，学生可以在本科入学后，使用AP成绩抵扣美国大学的学分。 <p>

                    </p>
                </div>
                <img src="../img/AP/Group 768.png" alt="" class="g3_right">
            </div>
        </div>
        <div class="ap4">
            <div class="ap4_cont">
                <div class="ap4_left">
                    <div class="ap4_left_di">
                        <p class="p1">AP</p>
                        <p class="p2">ADVANCED <br>PLACEMENT</p>
                        <p class="p3">AP考试成绩受到美国大学的广泛认可，例如：</p>

                    </div>

                </div>
                <div class="ap4_right">
                    <div class="ap4_item" @click="schoolDetail(406,'哈佛大学')">
                        <img src="../img/AP/1.jpg" alt="">
                        <div class="ap4_cover">
                            <p>哈佛大学</p>
                        </div>
                    </div>
                    <div class="ap4_item" @click="schoolDetail(19,'宾夕法尼亚大学')">
                        <img src="../img/AP/2.jpg" alt="" >
                        <div class="ap4_cover">
                            <p>宾夕法尼亚大学</p>
                        </div>
                    </div>
                    <div class="ap4_item" @click="schoolDetail(13,'哥伦比亚大学')">
                        <img src="../img/AP/3.jpg" alt="" >
                        <div class="ap4_cover">
                            <p>哥伦比亚大学</p>
                        </div>
                    </div>
                    <div class="ap4_item" @click="schoolDetail(101,'康奈尔大学')">
                        <img src="../img/AP/4.jpg" alt="">
                        <div class="ap4_cover">
                            <p>康奈尔大学</p>
                        </div>
                    </div>
                    <div class="ap4_item" @click="schoolDetail(18,'南加州大学')">
                        <img src="../img/AP/5.jpg" alt="">
                        <div class="ap4_cover">
                            <p>南加州大学</p>
                        </div>
                    </div>
                    <div class="ap4_item" @click="schoolDetail(3,'罗德岛设计学院')">
                        <img src="../img/AP/6.jpg" alt="">
                        <div class="ap4_cover">
                            <p>罗德岛设计学院</p>
                        </div>
                    </div>
                    <div class="ap4_item" @click="schoolDetail(9,'纽约大学')">
                        <img src="../img/AP/7.jpg" alt="">
                        <div class="ap4_cover">
                            <p>纽约大学</p>
                        </div>
                    </div>
                    <div class="ap4_item" @click="schoolDetail(33,'加州艺术大学')">
                        <img src="../img/AP/8.jpg" alt="">
                        <div class="ap4_cover">
                            <p>加州艺术大学</p>
                        </div>
                    </div>
                    <div class="ap4_item" @click="schoolDetail(8,'纽约视觉艺术学院')">
                        <img src="../img/AP/9.jpg" alt="">
                        <div class="ap4_cover">
                            <p>纽约视觉艺术学院</p>
                        </div>
                    </div>
                    <div class="ap4_item" @click="schoolDetail(1,'帕森斯设计学院')">
                        <img src="../img/AP/10.jpg" alt="">
                        <div class="ap4_cover">
                            <p>帕森斯设计学院</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="a3">
            <div class="g2_position"></div>
            <div class="section_title">
                <span class="section_cn">AP课程优势</span>
                <p class="section_en"></p>
            </div>
            <div class="a3_cont">
                <div class="a3_item" @click="a3itemClick(0)">
                    <img src="../img/alevel/Group 635-1.png" alt="" class="a3_item_bgc">
                    <div class="a3_item_text">
                        <div class="a3_item_text_title">美本直录助力</div>
                        <div class="a3_item_text_cont">由美国大学理事会官方开设，AP成绩已成为美国大学录取学生的重要参考依据</div>

                        <img src="../img/alevel/Group 643.png" alt="" class="a3_item_text_icon">
                    </div>
                </div>
                <div class="a3_item" @click="a3itemClick(1)">
                    <img src="../img/alevel/Group 636-1.png" alt="" class="a3_item_bgc">
                    <div class="a3_item_text">
                        <div class="a3_item_text_title">成绩可抵扣本科学分</div>
                        <div class="a3_item_text_cont">AP成绩可在入学后抵扣美国大学学分</div>

                        <img src="../img/alevel/Group 643.png" alt="" class="a3_item_text_icon">
                    </div>
                </div>
                <div class="a3_item" @click="a3itemClick(2)">
                    <img src="../img/alevel/Group 633-1.png" alt="" class="a3_item_bgc">
                    <div class="a3_item_text">
                        <div class="a3_item_text_title">考核方式灵活</div>
                        <div class="a3_item_text_cont">考试方式灵活：无笔试，提交作品获得成绩</div>

                        <img src="../img/alevel/Group 643.png" alt="" class="a3_item_text_icon">
                    </div>
                </div>
                <div class="a3_item" @click="a3itemClick(3)">
                    <img src="../img/alevel/Group 637-1.png" alt="" class="a3_item_bgc">
                    <div class="a3_item_text">
                        <div class="a3_item_text_title">课程产出同步作品集</div>
                        <div class="a3_item_text_cont">AP艺术作品可与院校作品集相融合，学术提升与留学申请高效同步。</div>

                        <img src="../img/alevel/Group 643.png" alt="" class="a3_item_text_icon">
                    </div>
                </div>


            </div>
        </div>

        <div class="a4">
            <div class="g2_position"></div>
            <!-- <div class="tag tag1"># 一对一</div> -->
            <div class="tag tag2"># AP 美高课程</div>
            <div class="tag tag3"># 官方审核机制</div>
            <div class="section_title">
                <span class="section_cn">RoSSo的服务与优势</span>
                <p class="section_en"></p>
            </div>
            <div class="a4_cont">

                <div class="a4_main">
                    <div class="a4_main_left">
                        <div class="a4_main_left_item" @click="dotClick(0)" style="font-weight: bold;">
                            <p> </p>
                            <span>开设科目</span>
                        </div>
                        <!-- <div class="a4_main_left_item" @click="dotClick(1)">
                            <p> </p>
                            <span>RoSSo优势</span>
                        </div> -->
                        <div class="a4_main_left_item" @click="dotClick(1)">
                            <p> </p>
                            <span>课程亮点</span>
                        </div>
                    </div>
                    <div class="a4_main_right">
                        <div class="a4_main_dot">
                            <div class="a4_main_dot_prev" @click="a4prev">
                                <div class="line1"></div>
                                <div class="line2"></div>
                            </div>
                            <div class="a4_main_dot_next" @click="a4next">
                                <div class="line1"></div>
                                <div class="line2"></div>
                            </div>
                        </div>
                        <div class="a4_main_right_banner" id="a4banner">
                            <div class="a4_main_right_item a4_main_right_item1">
                                <div class="a4_main_right_item_title">开设科目</div>
                               
                                <div class="a4_ap_cont" style="margin-top: 30px;">
                                    <div class="a4_ap_item">
                                        <img src="../img/AP/Rectangle 1088.jpg" alt="">
                                        <div>
                                            <p class="p1">2D科系</p>
                                            <p class="p2">2D subjects</p>
                                        </div>
                                    </div>
                                    <div class="a4_ap_item">
                                        <img src="../img/AP/Rectangle 1089.jpg" alt="">
                                        <div>
                                            <p class="p1">3D科系</p>
                                            <p class="p2">3D subjects</p>
                                        </div>
                                    </div>
                                    <div class="a4_ap_item">
                                        <img src="../img/AP/Rectangle 1090.jpg" alt="">
                                        <div>
                                            <p class="p1">绘画</p>
                                            <p class="p2">Drawing</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="a4_main_right_item_cont1">
                                    <P class="p1" style="font-weight: bold;font-size: 20px;line-height: 40px;">
                                        RoSSo对于AP选课有如下几点建议： </P>
                                    <P class="p2" style="line-height: 40px;">1.与本科阶段学习方向相匹配的科目<br>
                                        2.选择自己擅长相对好拿高分的科目，在申请中凸显学术竞争力 <br>3.建议申请前完成AP考试：申请时提交AP成绩，且完成的AP作品可用于院校申请作品集</P>
                                </div>
                            </div>
                          
                            <div class="a4_main_right_item a4_main_right_item3">
                                <div class="a4_main_right_item_title">课程亮点</div>
                                <div class="a4_main_right_item3_cont">
                                    <div class="a4_main_right_item3_cont_item">
                                        <img src="../img/alevel/Rectangle 1098.jpg" alt="">
                                        <div>
                                            <p>1对1针对性教学
                                                </p>
                                        </div>
                                    </div>
                                    <div class="a4_main_right_item3_cont_item">
                                        <img src="../img/alevel/Rectangle 1103.jpg" alt="">
                                        <div>
                                            <p>官方审核评估机制
                                                </p>
                                        </div>
                                    </div>
                                    <div class="a4_main_right_item3_cont_item">
                                        <img src="../img/AP/Rectangle 1105.jpg" alt="">
                                        <div>
                                            <p>AP成绩与作品集双重把控
                                               
                                            </p>
                                        </div>
                                    </div>
                                    <div class="a4_main_right_item3_cont_item">
                                        <img src="../img/alevel/Rectangle 1106.jpg" alt="">
                                        <div>
                                            <p>阶段性审核反馈，严控教学质量
                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="a4_main_right_item a4_main_right_item1">
                                <div class="a4_main_right_item_title">开设科目</div>
                              
                                <div class="a4_ap_cont" style="margin-top: 30px;">
                                    <div class="a4_ap_item">
                                        <img src="../img/AP/Rectangle 1088.jpg" alt="">
                                        <div>
                                            <p class="p1">2D科系</p>
                                            <p class="p2">2D subjects</p>
                                        </div>
                                    </div>
                                    <div class="a4_ap_item">
                                        <img src="../img/AP/Rectangle 1089.jpg" alt="">
                                        <div>
                                            <p class="p1">3D科系</p>
                                            <p class="p2">3D subjects</p>
                                        </div>
                                    </div>
                                    <div class="a4_ap_item">
                                        <img src="../img/AP/Rectangle 1090.jpg" alt="">
                                        <div>
                                            <p class="p1">绘画</p>
                                            <p class="p2">Drawing</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="a4_main_right_item_cont1" >
                                    <P class="p1" style="font-weight: bold;font-size: 20px;line-height: 40px;">
                                        RoSSo对于AP选课有如下几点建议： </P>
                                    <P class="p2" style="line-height: 40px;">1.与本科阶段学习方向相匹配的科目<br>
                                        2.选择自己擅长相对好拿高分的科目，在申请中凸显学术竞争力 <br>3.建议申请前完成AP考试：申请时提交AP成绩，且完成的AP作品可用于院校申请作品集</P>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="a5">
            <div class="g2_position"></div>
            <!-- <div class="section_title">
                <span class="section_cn">官方资料参考</span>
                <p class="section_en"></p>
            </div> -->
            <div class="a5_cont">


                <div class="a5_item">
                    <div class="a5_item_show" @click="a5Show(0)">
                        <div class="a5_item_show_title">• AP成绩等级</div>
                        <div class="cha" style="transform: rotate(225deg);">
                            <div class="cha_line1"></div>
                            <div class="cha_line2"></div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="a5_item_hid" style="display: flex;align-items: center;justify-content: space-between;">
                            <div class="a5_item2_title" style="width: 304px;">
                                * AP单科满分5分，大部分院校接受3分以上成绩，部分顶尖院校要求4分以上成绩。
                            </div>
                            <div class="a5_item2_table">
                                <table>
                                    <tr>
                                        <td
                                            style="width: 323px;font-size:22px;font-weight:bold;background-color: #DFB476;padding: 10px;">
                                            AP分数</td>
                                        <td
                                            style="width: 291px;font-size:22px;font-weight:bold;background-color: #DFB476;padding: 10px;">
                                            对应等级</td>

                                    </tr>
                                    <tr>
                                        <td>5分</td>
                                        <td>优秀</td>

                                    </tr>
                                    <tr>
                                        <td>4分</td>
                                        <td>良好</td>

                                    </tr>
                                    <tr>
                                        <td>3分</td>
                                        <td>及格</td>

                                    </tr>

                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="a5_item">
                    <div class="a5_item_show" @click="a5Show(1)">
                        <div class="a5_item_show_title">• AP考试评估标准</div>
                        <div class="cha">
                            <div class="cha_line1"></div>
                            <div class="cha_line2"></div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="a5_item_hid">


                            <div class="a5_item3_hid_cont">
                                <div class="a5_item3_hid_title"> 第一部分： Selected Works 自选作品<br>评估占比：40%</div>
                                <div class="a5_item3_hid_box">
                                    <img src="../img/alevel/Group 6622.png" alt="">
                                    <div>
                                        评估内容包含：<br>

                                        1. 五件作品：自选主题，可以相互关联/或不相关 <br>
                                        2. 选择最能展示素材、过程和想法的熟练融合的作品<br>
                                    </div>
                                </div>
                            </div>
                            <div class="a5_item3_line"></div>
                            <div class="a5_item3_hid_cont">
                                <div class="a5_item3_hid_title"> 第二部分： Sustained Investigation持续调研<br>评估占比：60%</div>
                                <div class="a5_item3_hid_box">
                                    <img src="../img/alevel/Group 6611.png" alt="">
                                    <div>
                                        评估内容：<br>

                                        1. 通过一系列相关材料，呈现对素材、<br>过程和想法的持续探究 <br>
                                        2. 练习、实验和修改的过程<br>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section_inp a6" style="margin-top: 180px;">
            <div class="s_inp_left">
                <img src="../img/shouchahua.png" alt="" class="img_shou  wow rotateInDownLeft" id="imgShou">
                <img src="../img/AP/Group 690.png" alt="" class="img_text  wow rollIn" id="imgText">
            </div>
            <div class="s_inp_right">
                <el-form :inline="true" :label-position="labelPosition" label-width="150px" :model="formLabelAlign">
                    <el-form-item label="姓名：">
                        <el-input v-model="formLabelAlign.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="意向专业：" class="elitem2">
                        <el-select v-model="formLabelAlign.region" placeholder="选择意向专业">
                            <el-option label="服装设计" value="服装设计"></el-option>
                            <el-option label="景观设计" value="景观设计"></el-option>
                            <el-option label="工业设计" value="工业设计"></el-option>
                            <el-option label="插画设计" value="插画设计"></el-option>
                            <el-option label="动画设计" value="动画设计"></el-option>
                            <el-option label="建筑设计" value="建筑设计"></el-option>
                            <el-option label="交互设计" value="交互设计"></el-option>
                            <el-option label="室内设计" value="室内设计"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电话：">
                        <el-input v-model="formLabelAlign.tel" placeholder="请输入电话号码"></el-input>
                    </el-form-item>
                    <el-form-item label="意向国家：" class="elitem2">
                        <el-select v-model="formLabelAlign.region2" placeholder="选择意向国家">
                            <el-option label="英国" value="England"></el-option>
                            <el-option label="美国" value="America"></el-option>
                            <el-option label="日本" value="Japan"></el-option>
                            <el-option label="新加坡" value="Singapore"></el-option>
                            <el-option label="韩国" value="Korea"></el-option>
                            <el-option label="欧洲" value="Europe"></el-option>

                            <el-option label="其他" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="意向专业：">
                    <el-input v-model="formLabelAlign.major" placeholder="请输入意向专业"></el-input>
                </el-form-item> -->
                    <el-form-item class="yuyue_box">
                        <div class="yuyue" @click="onSubmit()"></div>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <!--  -->
    </div>
</template>
<script>
import "@/assets/css/ap.css"
import axios from "axios"
export default {
    data() {
        return {
            imgsArr: [
                require("../img/alevel/Group 635.png"),
                require("../img/alevel/Group 636.png"),
                require("../img/alevel/Group 633.png"),
                require("../img/alevel/Group 637.png"),
                require("../img/alevel/Group 636.png"),
                require("../img/alevel/Group 637.png"),
                require("../img/alevel/Group 540.png"),
            ],
            imgsArr2: [
                require("../img/alevel/Group 635-1.png"),
                require("../img/alevel/Group 636-1.png"),
                require("../img/alevel/Group 633-1.png"),
                require("../img/alevel/Group 637-1.png"),
                require("../img/alevel/Group 636-1.png"),
                require("../img/alevel/Group 637-1.png"),
                require("../img/alevel/Group 540-1.png"),
            ],
            a4i: 0,
            labelPosition: 'right',
            formLabelAlign: {
                name: '',
                tel: '',
                region: '',
                region2: '',
                budget: '',
            },
        }
    },
    methods: {
        schoolDetail(val,val2) {
            // window.open(`https://public.rossoarts.com/schools/${val}.html`, "_blank")
            // this.$router.push(`/schools/${val}.html`)
            // this.$router.push(`/schools/${val}.html`)
            // console.log(val,val2);
            this.$router.push({
              
                path:  `/schools/${val}.html?cname=${val2}`,
              
            })
        },
        scrollg2item(val) {

            var g2_position = document.getElementsByClassName("g2_position")
            var g2_item = document.getElementsByClassName("g2_item")
            for (var i = 0; i < g2_item.length; i++) {
                g2_item[i].style.opacity = "0.5"
            }
            g2_item[val].style.opacity = "1"
            g2_position[val].scrollIntoView({
                block: 'start',
                behavior: 'smooth',

            })
        },
        onSubmit() {
            // console.log('submit!',this.formInline);
            var currentURL = window.location.href;
            var status = ''
            // 检查 URL 中是否包含某些关键词，来判断使用的搜索引擎
            if (currentURL.includes("google")) {
                status = "用户正在使用 Google 搜索引擎"
            } else if (currentURL.includes("bing")) {
                status = "用户正在使用 Bing 搜索引擎"
            } else if (currentURL.includes("yahoo")) {
                status = "用户正在使用 Yahoo 搜索引擎"
            } else if (currentURL.includes("baidu")) {
                status = "用户正在使用 百度 搜索引擎"
            } else {
                status = "无法确定用户使用的搜索引擎"
            }
            var patt = /^1[3-9][0-9]{9}$/

            if (this.formLabelAlign.name == "" || this.formLabelAlign.tel == "") {
                // console.log("姓名和手机号不能为空");
                this.$message.error('姓名和手机号不能为空');

            } else {
                // console.log("不是空");

                if (patt.test(this.formLabelAlign.tel)) {

                    // console.log("可以发请求");
                    // console.log(this.formInline);
                    axios.post("https://public.rossoarts.com/index/common/getform", {
                        "name": this.formLabelAlign.name,
                        "tel": this.formLabelAlign.tel,
                        "budget": this.formLabelAlign.budget,
                        "intended_country":this.formLabelAlign.region2,
                        "url": window.location.href,
                        "status": status,
                    }).then((data) => {
                        // console.log(data, "response");
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error, "error");
                    });

                } else {
                    console.log("手机号格式不正确");
                    this.$message.error('手机号格式不正确');

                }

            }


        },
        a5Show(val) {
            // console.log(val);
            var cha = document.getElementsByClassName("cha")
            var grid = document.getElementsByClassName("grid")
            // var t6_item_show = document.getElementsByClassName("t6_item_show")
            // var t6_imgQ = document.getElementsByClassName("t6_imgQ")
            // this.flag = !this.flag
            // console.log(grid[val].style.gridTemplateRows,val);
            if (grid[val].style.gridTemplateRows == "1fr") {
                // 折叠
                // console.log("不出");
                grid[val].style.gridTemplateRows = "0fr";
                cha[val].style.transform = "rotate(0deg)"
                // t6_item_show[val].style.backgroundColor = "#5f9df7"
                // t6_item_show[val].style.border = "none"
                // t6_item_show[val].style.margin = "0px"
                // t6_imgQ[val].style.visibility = "visible"
            } else {
                // 展开
                // console.log("出");
                grid[val].style.gridTemplateRows = "1fr";
                cha[val].style.transform = "rotate(225deg)"
                // t6_item_show[val].style.backgroundColor = "#FB6333"
                // t6_item_show[val].style.border = "2px solid #000"
                // t6_item_show[val].style.margin = "-2px -2px 0 -2px"
                // t6_imgQ[val].style.visibility = "hidden"

            }
        },
        dotClick(val) {
            // console.log(val);
            var a4_main_left_item = document.getElementsByClassName("a4_main_left_item")
            for (var i = 0; i < a4_main_left_item.length; i++) {
                a4_main_left_item[i].style.fontWeight = "400"
            }
            a4_main_left_item[val].style.fontWeight = "bold"
            this.a4i = val
            a4banner.style.transform = `translateX(${-915 * this.a4i}px)`
        },
        a4next() {
            var a4_main_left_item = document.getElementsByClassName("a4_main_left_item")
            // var a4_main_right_item = document.getElementsByClassName("a4_main_right_item")
            this.a4i++;
            // console.log(a4_main_right_item[this.a4i]);
            // a4banner.style.height = a4_main_left_item[this.a4i].style.height
            a4banner.style.transform = `translateX(${-915 * this.a4i}px)`
            a4banner.style.transition = 'all .36s'
            if (this.a4i == 2) {
                this.a4i = 0;
                setTimeout(() => {
                    a4banner.style.transform = 'translate(0,0)';
                    a4banner.style.transition = 'none'
                }, 360);

            }
            for (var i = 0; i < a4_main_left_item.length; i++) {
                a4_main_left_item[i].style.fontWeight = "400"
            }
            a4_main_left_item[this.a4i].style.fontWeight = "bold"
        },
        a4prev() {
            var a4_main_left_item = document.getElementsByClassName("a4_main_left_item")
            this.a4i--;
            if (this.a4i == -1) {
                this.a4i = 1;//length - 1

                a4banner.style.transition = 'none'

                a4banner.style.transform = `translateX(${-915 * (this.a4i + 1)}px)`
                setTimeout(() => {
                    a4banner.style.transform = 'translateX(' + (-this.a4i * 915) + 'px)';
                    a4banner.style.transition = 'all .36s'
                }, 1);

            } else {
                a4banner.style.transition = 'all 0.36s'
                a4banner.style.transform = `translateX(${-915 * this.a4i}px)`
            }
            for (var i = 0; i < a4_main_left_item.length; i++) {
                a4_main_left_item[i].style.fontWeight = "400"
            }
            a4_main_left_item[this.a4i].style.fontWeight = "bold"

        },
        a3itemClick(val) {
            console.log(val);
            var a3_item_bgc = document.getElementsByClassName("a3_item_bgc")
            var a3_item = document.getElementsByClassName("a3_item")
            var a3_item_text = document.getElementsByClassName("a3_item_text")
            var a3_item_text_cont = document.getElementsByClassName("a3_item_text_cont")
            var a3_item_text_icon = document.getElementsByClassName("a3_item_text_icon")

            if (a3_item_text_cont[val].style.display == "block") {
                a3_item_bgc[val].src = this.imgsArr2[val]
                a3_item_text[val].style.height = "40px"
                a3_item_text[val].style.marginTop = "95px"
                a3_item[val].style.backgroundColor = "#5F9DF7"
                a3_item_text_cont[val].style.display = "none"
                a3_item_text_icon[val].src = require("../img/alevel/Group 643.png")
                a3_item[val].style.height = "165px"
            } else {
                a3_item_bgc[val].src = this.imgsArr[val]
                a3_item_text[val].style.height = "230px"
                a3_item_text[val].style.marginTop = "25px"
                a3_item[val].style.backgroundColor = "#2E7FF5"
                a3_item[val].style.height = "282px"
                a3_item_text_cont[val].style.display = "block"
                a3_item_text_icon[val].src = require("../img/alevel/Group 644.png")
            }
        },
    },
    created() {

    }
}
</script>